import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CalendarSleek = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 21" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.833 3.208c.345 0 .625.28.625.625v1.39c2.357-.21 4.727-.21 7.084 0v-1.39a.625.625 0 0 1 1.25 0v1.514a2.813 2.813 0 0 1 2.393 2.416l.072.544a24.16 24.16 0 0 1-.078 6.89 2.508 2.508 0 0 1-2.231 2.11l-.995.098c-2.629.26-5.277.26-7.906 0l-.995-.098a2.508 2.508 0 0 1-2.232-2.11 24.162 24.162 0 0 1-.077-6.89l.072-.544a2.813 2.813 0 0 1 2.393-2.416V3.833c0-.345.28-.625.625-.625zm.371 3.295a38.676 38.676 0 0 1 7.592 0l.754.074c.722.071 1.3.63 1.396 1.35l.072.544c.025.19.048.38.069.57H3.913c.02-.19.044-.38.069-.57l.072-.544a1.563 1.563 0 0 1 1.396-1.35l.754-.074zm-2.39 3.789a22.912 22.912 0 0 0 .242 4.713 1.258 1.258 0 0 0 1.12 1.058l.993.098c2.548.251 5.114.251 7.662 0l.994-.098a1.258 1.258 0 0 0 1.12-1.058c.242-1.56.323-3.14.24-4.713H3.815z"
        fill={color}
      />
    </StyledIcon>
  );
};

CalendarSleek.propTypes = {
  color: PropTypes.string
};

CalendarSleek.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default CalendarSleek;
